import _ from 'lodash'

import Api from '@/misc/api'
import { getUrlQuery } from '@/misc/string_utils'

import { updateHomeList } from './utils'

export default {
  state: {
    savedSearches: [],
    // TODO: To rename Sancare
    sancareSavedSearchesCategories: [],
    savedSearchesGroups: [],
    recentlyUsedSearches: {},

    fetchSavedSearchesRequest: { fetching: false, error: null, ok: false },
    fetchRecentlyUsedSearchesRequest: { fetching: false, error: null, ok: false },
    addSavedSearchRequest: { fetching: false, error: null, ok: false },
    editSavedSearchRequest: { fetching: false, error: null, ok: false },
    removeSavedSearchRequest: { fetching: false, error: null, ok: false },
    enableSavedSearchRequest: { fetching: false, error: null, ok: false },
    disableSavedSearchRequest: { fetching: false, error: null, ok: false },
    enableAutomationSavedSearchRequest: { fetching: false, error: null, ok: false },
    validateTeamSearchRequest: { fetching: false, error: null, ok: false },
    toBeRemovedTeamSearchRequest: { fetching: false, error: null, ok: false },

    fetchSancareSavedSearchesCategoriesRequest: { fetching: false, error: null, ok: false },

    fetchSavedSearchesGroupsRequest: { fetching: false, error: null, ok: false },
    addSavedSearchesGroupRequest: { fetching: false, error: null, ok: false },
    fetchSavedSearchesGroupRequest: { fetching: false, error: null, ok: false },
    removeSavedSearchesGroupRequest: { fetching: false, error: null, ok: false },
    addSearchInGroupRequest: { fetching: false, error: null, ok: false },
    removeSearchFromGroupRequest: { fetching: false, error: null, ok: false },
  },
  mutations: {
    fetchSavedSearchesStart(state) {
      state.fetchSavedSearchesRequest = { fetching: true, error: null, ok: false }
    },
    fetchSavedSearchesSuccess(state, response) {
      state.fetchSavedSearchesRequest = { fetching: false, error: null, ok: true }
      state.savedSearches = updateHomeList(state.savedSearches, response.searches, response.stats)
    },
    fetchSavedSearchesError(state, res) {
      state.fetchSavedSearchesRequest = { fetching: false, error: res.message, ok: false }
      state.savedSearches = []
    },
    addSavedSearchStart(state) {
      state.addSavedSearchRequest = { fetching: true, error: null, ok: false }
    },
    addSavedSearchSuccess(state, savedSearch) {
      state.addSavedSearchRequest = { fetching: false, error: null, ok: true }
      state.savedSearches.push(savedSearch)
      return savedSearch
    },
    addSavedSearchError(state, res) {
      state.addSavedSearchRequest = { fetching: false, error: res.message, ok: false }
    },
    fetchSavedSearchStart(state) {
      state.fetchSavedSearchRequest = { fetching: true, error: null, ok: false }
    },
    fetchSavedSearchSuccess(state, search) {
      state.fetchSavedSearchRequest = { fetching: false, error: null, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
      return search
    },
    fetchSavedSearchError(state, res) {
      state.fetchSavedSearchRequest = { fetching: false, error: res.message, ok: false }
    },
    addSearchInGroupStart(state) {
      state.addSearchInGroupRequest = { fetching: true, error: null, ok: false }
    },
    addSearchInGroupSuccess(state, rawGroup) {
      state.addSearchInGroupRequest = { fetching: false, error: null, ok: true }
      const group = state.savedSearchesGroups.find((g) => g.id === rawGroup.id)
      group.savedSearches = rawGroup.savedSearches
    },
    addSearchInGroupError(state, res) {
      state.addSearchInGroupRequest = { fetching: false, error: res.message, ok: false }
    },
    removeSearchFromGroupStart(state) {
      state.removeSearchFromGroupRequest = { fetching: true, error: null, ok: false }
    },
    removeSearchFromGroupSuccess(state, rawGroup) {
      state.removeSearchFromGroupRequest = { fetching: false, error: null, ok: true }
      const group = state.savedSearchesGroups.find((g) => g.id === rawGroup.id)
      group.savedSearches = rawGroup.savedSearches
    },
    removeSearchFromGroupError(state, res) {
      state.removeSearchFromGroupRequest = { fetching: false, error: res.message, ok: false }
    },
    editSavedSearchStart(state) {
      state.editSavedSearchRequest = { fetching: true, error: null, ok: false }
    },
    editSavedSearchSuccess(state, search) {
      state.editSavedSearchRequest = { fetching: false, error: null, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
      return search
    },
    editSavedSearchError(state, res) {
      state.editSavedSearchRequest = { fetching: false, error: res.message, ok: false }
    },
    removeSavedSearchStart(state) {
      state.removeSavedSearchRequest = { fetching: true, error: null, ok: false }
    },
    removeSavedSearchSuccess(state, searchId) {
      state.removeSavedSearchRequest = { fetching: false, error: false, ok: true }
      state.savedSearches = _.filter(state.savedSearches, (s) => s.id !== searchId)
    },
    removeSavedSearchError(state, res) {
      state.removeSavedSearchRequest = { fetching: false, error: res.message, ok: false }
    },
    enableSavedSearchStart(state) {
      state.enableSavedSearchRequest = { fetching: true, error: null, ok: false }
    },
    enableSavedSearchSuccess(state, search) {
      state.enableSavedSearchRequest = { fetching: false, error: false, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
    },
    enableSavedSearchError(state, res) {
      state.enableSavedSearchRequest = { fetching: false, error: res.message, ok: false }
    },
    disableSavedSearchStart(state) {
      state.disableSavedSearchRequest = { fetching: false, error: null, ok: false }
    },
    disableSavedSearchSuccess(state, search) {
      state.disableSavedSearchRequest = { fetching: false, error: false, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
    },
    disableSavedSearchError(state, res) {
      state.disableSavedSearchRequest = { fetching: false, error: res.message, ok: false }
    },

    fetchSancareSavedSearchesCategoriesStart(state) {
      state.fetchSavedSearchesRequest = { fetching: true, error: null, ok: false }
    },
    fetchSancareSavedSearchesCategoriesSuccess(state, response) {
      state.fetchSancareSavedSearchesCategoriesRequest = { fetching: false, error: null, ok: true }
      state.sancareSavedSearchesCategories = updateHomeList(state.sancareSavedSearchesCategories, response.categories, response.stats)
    },
    fetchSancareSavedSearchesCategoriesError(state, res) {
      state.fetchSavedSearchesRequest = { fetching: false, error: res.message, ok: false }
      state.sancareSavedSearchesCategories = []
    },
    fetchSavedSearchesGroupsStart(state) {
      state.fetchSavedSearchesGroupsRequest = { fetching: true, error: null, ok: false }
    },
    // replace only fetched groups
    fetchSavedSearchesGroupsSuccess(state, response) {
      state.fetchSavedSearchesGroupsRequest = { fetching: false, error: null, ok: true }
      state.savedSearchesGroups = updateHomeList(state.savedSearchesGroups, response.searchesGroups, response.stats)
    },
    fetchSavedSearchesGroupsError(state, res) {
      state.fetchSavedSearchesGroupsRequest = { fetching: false, error: res.message, ok: false }
      state.savedSearchesGroups = []
    },
    addSavedSearchesGroupStart(state) {
      state.addSavedSearchesGroupRequest = { fetching: true, error: null, ok: false }
    },
    addSavedSearchesGroupSuccess(state, { searchesGroup, stats }) {
      state.addSavedSearchesGroupRequest = { fetching: false, error: null, ok: true }
      state.savedSearchesGroups.push({ ...searchesGroup, ...stats[0] })
    },
    addSavedSearchesGroupError(state, res) {
      state.addSavedSearchesGroupRequest = { fetching: false, error: res.message, ok: false }
    },
    removeSavedSearchesGroupStart(state) {
      state.removeSavedSearchesGroupRequest = { fetching: true, error: null, ok: false }
    },
    removeSavedSearchesGroupSuccess(state, groupId) {
      state.removeSavedSearchesGroupRequest = { fetching: false, error: false, ok: true }
      state.savedSearchesGroups = _.filter(state.savedSearchesGroups, (group) => group.id !== groupId)
    },
    removeSavedSearchesGroupError(state, res) {
      state.removeSavedSearchesGroupRequest = { fetching: false, error: res.message, ok: false }
    },
    enableAutomationSavedSearchStart(state) {
      state.enableAutomationSavedSearchRequest = { fetching: true, error: null, ok: false }
    },
    enableAutomationSavedSearchSuccess(state, search) {
      state.enableAutomationSavedSearchRequest = { fetching: false, error: null, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
    },
    enableAutomationSavedSearchError(state, res) {
      state.enableAutomationSavedSearchRequest = { fetching: true, error: res.message, ok: false }
    },
    validateTeamSearchStart(state) {
      state.validateTeamSearchRequest = { fetching: true, error: null, ok: false }
    },
    validateTeamSearchSuccess(state, search) {
      state.validateTeamSearchRequest = { fetching: false, error: null, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
    },
    validateTeamSearchError(state, res) {
      state.validateTeamSearchRequest = { fetching: true, error: res.message, ok: false }
    },
    toBeRemovedTeamSearchStart(state) {
      state.toBeRemovedTeamSearchRequest = { fetching: true, error: null, ok: false }
    },
    toBeRemovedTeamSearchSuccess(state, search) {
      state.toBeRemovedTeamSearchRequest = { fetching: false, error: null, ok: true }
      state.savedSearches = _.map(state.savedSearches, (s) => s.id === search.id ? { ...s, ...search } : s)
    },
    toBeRemovedTeamSearchError(state, res) {
      state.toBeRemovedTeamSearchRequest = { fetching: true, error: res.message, ok: false }
    },
    fetchRecentlyUsedSearchesStart(state) {
      state.fetchRecentlyUsedSearchesRequest = { fetching: true, error: null, ok: false }
    },
    fetchRecentlyUsedSearchesSuccess(state, { mode, response }) {
      state.fetchRecentlyUsedSearchesRequest = { fetching: false, error: null, ok: true }
      // Préserve l'ordre renvoyé par l'API (plus récent en tête) et fusionne les stats par id.
      const merged = response.searches.map((search) => {
        const stats = response.stats.find((stat) => stat.id === search.id) || { countStay: 0, countTodoStay: 0 }
        return { ...search, ...stats }
      })
      // Indexé par mode pour que chaque onglet conserve sa propre liste.
      state.recentlyUsedSearches = { ...state.recentlyUsedSearches, [mode]: merged }
    },
    fetchRecentlyUsedSearchesError(state, res) {
      state.fetchRecentlyUsedSearchesRequest = { fetching: false, error: res.message, ok: false }
    },
  },
  actions: {
    fetchSavedSearches({ commit }, urlArgs) {
      const urlParams = `?${getUrlQuery(urlArgs)}`
      return Api.get(
        {
          url: `/api/saved-search/searches${urlParams}`,
          startMut: 'fetchSavedSearchesStart',
          successMut: 'fetchSavedSearchesSuccess',
          errorMut: 'fetchSavedSearchesError',
        },
        commit
      )
    },
    fetchRecentlyUsedSearches({ commit }, urlArgs) {
      const urlParams = `?${getUrlQuery(urlArgs)}`
      return Api.get(
        {
          url: `/api/saved-search/recently-used${urlParams}`,
          startMut: 'fetchRecentlyUsedSearchesStart',
          successMut: (response) => commit('fetchRecentlyUsedSearchesSuccess', { mode: urlArgs.searchMode, response }),
          errorMut: 'fetchRecentlyUsedSearchesError',
        },
        commit
      )
    },
    recordRecentlyUsedSearch({ commit }, searchId) {
      return Api.post(
        { url: `/api/saved-search/${searchId}/recently-used`, body: '' },
        commit
      )
    },
    addSavedSearch({ commit }, search) {
      return Api.post(
        {
          url: '/api/saved-search/add-search',
          body: search,
          startMut: 'addSavedSearchStart',
          successMut(s) {
            commit('addSavedSearchSuccess', s)
            // call to mutation 'switchToEditSavedSearch' located in the stay-list store.js
            commit('switchToEditSavedSearch', s)
          },

          errorMut: 'addSavedSearchError',
        },
        commit
      )
    },
    fetchSavedSearch({ commit }, searchId) {
      return Api.get(
        {
          url: `/api/saved-search/${searchId}`,
          startMut: 'fetchSavedSearchStart',
          successMut: 'fetchSavedSearchSuccess',
          errorMut: 'fetchSavedSearchError',
        },
        commit
      )
    },
    addSearchInGroup({ commit }, payload) {
      return Api.post(
        {
          url: `/api/search-group/${payload.groupId}/search/${payload.searchId}`,
          startMut: 'addSearchInGroupStart',
          successMut: 'addSearchInGroupSuccess',
          errorMut: 'addSearchInGroupError',
        },
        commit
      )
    },
    removeSearchFromGroup({ commit }, payload) {
      return Api.del(
        {
          url: `/api/search-group/${payload.groupId}/search/${payload.searchId}`,
          startMut: 'removeSearchFromGroupStart',
          successMut: 'removeSearchFromGroupSuccess',
          errorMut: 'removeSearchFromGroupError',
        },
        commit
      )
    },
    editSavedSearch({ commit }, search) {
      return Api.put(
        {
          url: `/api/saved-search/search-${search.id}`,
          body: search,
          startMut: 'editSavedSearchStart',
          successMut: 'editSavedSearchSuccess',
          errorMut: 'editSavedSearchError',
        },
        commit
      )
    },
    removeSavedSearch({ commit }, searchId) {
      return Api.del(
        {
          url: `/api/saved-search/search-${searchId}`,
          body: '',
          startMut: 'removeSavedSearchStart',
          successMut: () => commit('removeSavedSearchSuccess', searchId),
          errorMut: 'removeSavedSearchError',
        },
        commit
      )
    },
    fetchSancareSavedSearchesCategories({ commit }, urlArgs) {
      let urlParams = ''
      if (urlArgs) {
        urlParams = `?${getUrlQuery(urlArgs)}`
      }

      return Api.get(
        {
          url: `/api/saved-search/sancare-categories${urlParams}`,
          startMut: 'fetchSancareSavedSearchesCategoriesStart',
          successMut: 'fetchSancareSavedSearchesCategoriesSuccess',
          errorMut: 'fetchSancareSavedSearchesCategoriesError',
        },
        commit
      )
    },
    fetchSavedSearchesGroups({ commit }, urlArgs) {
      const urlParams = `?${getUrlQuery(urlArgs)}`

      return Api.get(
        {
          url: `/api/saved-search/groups${urlParams}`,
          startMut: 'fetchSavedSearchesGroupsStart',
          successMut: 'fetchSavedSearchesGroupsSuccess',
          errorMut: 'fetchSavedSearchesGroupsError',
        },
        commit
      )
    },
    addSavedSearchesGroup({ commit }, group) {
      return Api.post(
        {
          url: '/api/saved-search/group',
          body: group,
          startMut: 'addSavedSearchesGroupStart',
          successMut: 'addSavedSearchesGroupSuccess',
          errorMut: 'addSavedSearchesGroupError',
        },
        commit
      )
    },
    removeSavedSearchesGroup({ commit }, groupId) {
      return Api.del(
        {
          url: `/api/saved-search/group/${groupId}`,
          startMut: 'removeSavedSearchesGroupStart',
          successMut: () => commit('removeSavedSearchesGroupSuccess', groupId),
          errorMut: 'removeSavedSearchesGroupError',
        },
        commit
      )
    },
    enableSavedSearch({ commit }, searchId) {
      return Api.put(
        {
          url: `/api/saved-search/${searchId}/enable`,
          startMut: 'enableSavedSearchStart',
          successMut: 'enableSavedSearchSuccess',
          errorMut: 'enableSavedSearchError'
        },
        commit
      )
    },
    disableSavedSearch({ commit }, searchId) {
      return Api.put(
        {
          url: `/api/saved-search/${searchId}/disable`,
          startMut: 'disableSavedSearchStart',
          successMut: 'disableSavedSearchSuccess',
          errorMut: 'disableSavedSearchError'
        },
        commit
      )
    },
    validateTeamSearch({ commit }, { searchId }) {
      return Api.put(
        {
          url: `/api/saved-search/${searchId}/validate-team-search`,
          startMut: 'validateTeamSearchStart',
          successMut: 'validateTeamSearchSuccess',
          errorMut: 'validateTeamSearchError',
        },
        commit
      )
    },
    toBeRemovedTeamSearch({ commit }, { searchId, toBeRemoved }) {
      return Api.put(
        {
          url: `/api/saved-search/${searchId}/toberemoved-team-search`,
          body: { toBeRemoved },
          startMut: 'toBeRemovedTeamSearchStart',
          successMut: 'toBeRemovedTeamSearchSuccess',
          errorMut: 'toBeRemovedTeamSearchError',
        },
        commit
      )
    }
  },
}
